import type { AppStore } from "@/store";

const CHECKOUT_RETURN_CONFIRMATION_ATTEMPTS = 3;

/** Reconciles a Stripe return until the refreshed subscription proves access. */
export async function confirmStripeCheckoutReturn({
  isConfirmed,
  store,
}: {
  isConfirmed: () => boolean;
  store: AppStore;
}): Promise<boolean> {
  let lastError: unknown;

  for (let attempt = 0; attempt < CHECKOUT_RETURN_CONFIRMATION_ATTEMPTS; attempt += 1) {
    try {
      await store.platformInfo.fetchPlatformInfo({ reconcileStripeSubscription: true });
      lastError = undefined;
      if (isConfirmed()) {
        return true;
      }
    } catch (error) {
      lastError = error;
    }
  }

  if (lastError !== undefined) {
    throw lastError;
  }

  return false;
}
